<div class="cardPaymentsWrap">
    <div class="maxContainerWidth flex md:flex-row flex-col  justify-between items-end sm:items-center gap-6 md:gap-2">
        <div class="contentWrap">
            <h4 class="text-gradient">Payment Methods </h4>
            <h2> Accept Card <span>Payments</span> </h2>
            <p class="mb-8"> Paid makes it very quick and easy for small and medium-sized merchants, eCommerce sites and marketplaces to accept card payments. Paid’s pre-built integrations link seamlessly with your checkout page to ensure a quick and secure checkout flow for your customers. </p>
            <p> Our responsive design displays checkout page correctly on all the devices. And our secure checkout builds confidence and increases conversions saving you cost and time to accepting payments. </p>

        </div>
        <div class="imageWrap">
            <div class="card-bg"></div>
            <img src="assets/images/payment-gateway/credit-card-mockup.png" alt="">
        </div>
    </div>
</div>